import * as React from "react";
import { useState, useEffect, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import { Button as PrimeButton } from "primereact/button";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import Loader from "../common/Loader";
import { CircularProgress } from "@mui/material";
import CustomDialog from "../common/CustomDialog";
import { TrackNowButton } from "../ui/TrackNowButton";
import AuthContext from "../../context/auth/AuthContext";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box } from "@mui/material";
import { tokens } from "../../theme/tokens";
import { useCommonDetailsContext } from "../../context/Common/common";


const ProgramNamesList = (props) => {
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const containerBackgroundColor = tokens.colors.offWhite;
  const tableBackgroundColor = containerBackgroundColor;
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [rows, setRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowForDelete, setSelectedRowForDelete] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = React.useState("1");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert1, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
  const authContext = useContext(AuthContext);
  const { authUser } = authContext;
  const [apiResponse, setApiResponse] = useState(null)

  const postAwardProgram = useContext(FilingMasterContext);
  const {
    getPostProgram,
    deletePostProgram,
    filingMasterLoading,
    postProgram,
  } = postAwardProgram;
  useEffect(() => {
    if (props.isTableLoading) {
      console.log("props-loading", props.isTableLoading);
    }
  }, [props.isTableLoading]);

  const fetchPostProgram = async () => {
    setIsLoading(true);
    console.log("@@Fetch PostProgram:", getPostProgram);
    try {
      if (getPostProgram) {
        console.log("@@Fetch PostProgram:");
        try {
          const catList = await getPostProgram();
          console.log("@@PostProgram:", catList);
          // setRows(catList);
        } catch (error) {
          console.log("@@Error:", error);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPostProgram();
  }, []);



  useEffect(() => {
    if (postProgram) {
      console.log("postProgram#", postProgram);
      setRows(postProgram);
    }
  }, [postProgram]);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    props.selectRowForEdit(selectedRow);
  };

  const handleDelete = async () => {
    console.log("SHOW DIALOG", selectedRow);
    setSelectedRowForDelete(selectedRow);
    setDialogMessage(
      `Are you sure to delete the Program Name: ${selectedRow.programName}?`
    );
    setShowConfirmDialog(true);
    handleMenuClose();
  };

  const deleteCategory = async () => {
    console.log("SHOW DIALOG2", selectedRow);
    console.log("selectedRowForDelete3", selectedRowForDelete);
    setIsLoading(true);
    setShowConfirmDialog(false);
    props.formReset();
    try {
      const res = await deletePostProgram(selectedRowForDelete, authUser.userId);
      console.log("res", res, "sel", selectedRowForDelete);
      if (res.status === "Success") {
        setApiResponse(res);
        setShowAlert(true);
      } else {
        setApiResponse(res);
        setShowAlert(true);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
    setSelectedRowForDelete(null);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };
  const footerContent = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
      <TrackNowButton
        variant="primary"
        onClick={() => closeAlert()}
      >
        OK
      </TrackNowButton>
    </div>
  );
  const closeAlert = () => {
    setShowAlert(false);
  };

  const filteredRows = rows.filter((row) => {
    return (
      row.programName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      row.programId.toString().includes(searchText)
    );
  });

  return (
    <>

      <CustomDialog header="Info" visible={showAlert1} onHide={closeAlert} footer={null}>
        <Box sx={{ width: "100%", fontWeight: 400 }}>
          {apiResponse === "Success" ? (
            <Typography sx={{ fontWeight: 400 }}>
              Successfully deleted the program name{" "}
              {selectedRowForDelete && (<Typography fontWeight="bold" component="span">
                {selectedRowForDelete.businessCategoryName}
              </Typography>)}

            </Typography>
          ) : (
            <Box>
              <div>
                <Typography>
                  {apiResponse?.errorMessage}
                </Typography>
              </div>
              <div>
                {apiResponse?.details && (
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: '1px solid #e5e7eb' }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                        sx={{
                          '& .MuiTab-root': {
                            color: '#6b7280',
                            '&.Mui-selected': {
                              color: tableHeaderColor,
                            },
                          },
                          '& .MuiTabs-indicator': {
                            backgroundColor: tableHeaderColor,
                          },
                        }}
                      >
                        <Tab label="Client List" value="1" />
                        <Tab label="Filing List" value="2" />
                      </TabList>
                    </Box>
                    <TabPanel style={{ padding: "0px" }} value="1">
                      <ul>
                        {apiResponse?.details?.customerNames.map((item, index) => (

                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </TabPanel>
                    <TabPanel style={{ padding: "0px" }} value="2">
                      <ul>
                        {apiResponse?.details?.filingNames.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </TabPanel>
                  </TabContext>
                )}
              </div>
            </Box>
          )}
        </Box>
      </CustomDialog>
      <style>{`
        .p-checkbox .p-checkbox-box.p-highlight {
          background: ${tableHeaderColor} !important;
          border-color: ${tableHeaderColor} !important;
        }
      `}</style>
      <Box sx={{ mt: 2, height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>
        <TextField
          placeholder="Search"
          value={searchText}
          onChange={handleSearch}
          size="small"
          fullWidth
          sx={{
            width: "100%",
            mb: 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: '20px',
              backgroundColor: containerBackgroundColor
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon sx={{ color: tableHeaderColor }} />
              </InputAdornment>
            ),
          }}
        />
        <Paper
          sx={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            borderRadius: "8px",
            boxShadow: "none",
            padding: "1.5rem",
            backgroundColor: containerBackgroundColor,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TableContainer
            sx={{
              borderRadius: "8px",
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              backgroundColor: containerBackgroundColor,
            }}
          >
          <Table
            stickyHeader
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: 0,
              tableLayout: "fixed",
            }}
          >
            <TableHead>
              <TableRow sx={{ background: tableHeaderColor }}>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#ffffff",
                    background: tableHeaderColor,
                    borderRight: "1px solid rgba(255, 255, 255, 0.5)",
                    borderBottom: "none",
                    padding: "12px 16px",
                    letterSpacing: "0.02em",
                    "&:first-of-type": {
                      borderTopLeftRadius: "8px",
                    },
                  }}
                >
                  Program Name
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#ffffff",
                    background: tableHeaderColor,
                    borderRight: "none",
                    borderBottom: "none",
                    padding: "12px 16px",
                    letterSpacing: "0.02em",
                    "&:last-of-type": {
                      borderTopRightRadius: "8px",
                    },
                  }}
                >
                  Description
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading || props.isTableLoading ? (
                <TableRow style={{ borderBottom: "none" }}>
                  <TableCell
                    colSpan={2}
                    style={{ textAlign: "center", borderBottom: "none" }}
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row) => (
                  <TableRow
                    key={row.programId}
                    sx={{
                      height: "56px",
                      "&:last-child td:first-of-type": {
                        borderBottomLeftRadius: "8px",
                      },
                      "&:last-child td:last-of-type": {
                        borderBottomRightRadius: "8px",
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        backgroundColor: tableBackgroundColor,
                        padding: "0 12px",
                        fontSize: "15px",
                        color: "#000000",
                        borderRight: `1px solid ${tableHeaderColor}`,
                        borderBottom: `1px solid ${tableHeaderColor}`,
                        borderLeft: "none",
                        borderTop: "none",
                        height: "56px",
                        minHeight: "56px",
                        maxHeight: "56px",
                        verticalAlign: "middle",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.programName}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: tableBackgroundColor,
                        padding: "0 12px",
                        fontSize: "15px",
                        color: "#000000",
                        borderRight: "none",
                        borderBottom: `1px solid ${tableHeaderColor}`,
                        borderLeft: "none",
                        borderTop: "none",
                        height: "56px",
                        minHeight: "56px",
                        maxHeight: "56px",
                        verticalAlign: "middle",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "100%",
                          minHeight: "56px",
                        }}
                      >
                        <span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {row.programDescription}
                        </span>
                        <IconButton
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          onClick={(event) => handleMenuClick(event, row)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        </Paper>
      </Box>
      <CustomDialog
        visible={showConfirmDialog}
        onHide={() => setShowConfirmDialog(false)}
        onConfirm={deleteCategory}
        confirmLabel="Confirm"
      >
        {dialogMessage}
      </CustomDialog>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </>
  );
};

export default ProgramNamesList;
